<script setup lang="ts">
// ランキングページ共通のセクション見出し（既存 ArticleSection h2 のグラデ見出し + emblemアイコン）
defineProps<{
  // 見出し左のemblemアイコン画像パス（~/assets/images/... 形式）
  icon: string;
  // 見出しテキスト
  title: string;
  // アンカースクロール用のid（任意）
  anchorId?: string;
}>();
</script>

<template>
  <h2 :id="anchorId" class="secHeading">
    <img class="secHeading-icon" :src="icon" alt="" />
    <span class="secHeading-text">{{ title }}</span>
  </h2>
</template>

<style lang="scss" scoped>
.secHeading {
  display: flex;
  align-items: center;
  gap: 7px;
  border-top: 2px solid $colorContentsBorder;
  border-bottom: 1px solid #fff;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(244, 244, 244, 1) 100%
  );
  background-size: 100% 100%;
  box-shadow: 0px 1px 0px 0px #dcdcdc;
}

#review-house {
  &.secHeading {
    padding: 8px 20px;
  }
}

#review-mansion {
  &.secHeading {
    padding: 8px 23px;
  }
}

.howto {
  .secHeading {
    padding: 8px 17px;
    .secHeading-icon {
      width: 21px;
      height: auto;
    }
  }
}

.flow {
  .secHeading {
    padding: 8px 19px;
    .secHeading-icon {
      width: 16px;
      height: auto;
    }
  }
}

.secHeading-icon {
  width: 32px;
  height: 32px;
  flex: none;
  object-fit: contain;
}

.secHeading-text {
  font-size: px(18);
  font-weight: 700;
  color: $colorBasicText;
  line-height: px(24);
}

@include media(pc) {
  .secHeading {
    border-top-width: 3px;
    gap: 4px;
  }

  #review-house {
    &.secHeading {
      padding: 8px 25px;
    }
  }

  #review-mansion {
    &.secHeading {
      padding: 8px 25px;
    }
  }

  .howto {
    .secHeading {
      padding: 8px 24px;
      .secHeading-icon {
        width: 27px;
        height: auto;
      }
    }
  }

  .flow {
    .secHeading {
      padding: 8px 28px;
      .secHeading-icon {
        width: 20px;
        height: auto;
      }
    }
  }

  .secHeading-icon {
    width: 40px;
    height: 40px;
  }

  .secHeading-text {
    font-size: px(21.9);
  }
}
</style>
